import { Service } from './service.decorator';
export function JSService(optionsOrDependencies, dependenciesOrConstructor, maybeConstructor) {
    let constructor;
    if (typeof dependenciesOrConstructor === 'function') {
        // eslint-disable-next-line
        constructor = dependenciesOrConstructor;
        Service(optionsOrDependencies)(constructor);
    }
    else if (maybeConstructor) {
        constructor = maybeConstructor;
        Service(optionsOrDependencies, dependenciesOrConstructor)(constructor);
    }
    if (!constructor) {
        throw Error('The JSService overload was not used correctly.');
    }
    return constructor;
}
//# sourceMappingURL=js-service.decorator.js.map